import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "@app/core/user/domain/user";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { UserMapper } from "@app/core/user/data/network/user.mapper";

@Injectable({
  providedIn: "root",
})
export class EditUserProfileWS {
  constructor(private handler: BaseHandler) {}

  execute(params: { token: string; profile: User }): Observable<User> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.put)
      .setAuthorization(new TokenAuthorization(params.token))
      .setUrl(ApiUrls.EDIT_PROFILE_ENDPOINT())
      .setBody(UserMapper.serialize(params.profile))
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((response) => UserMapper.deserialize(response)));
  }
}
